import { getHttpApi } from '@cian/http-api/browser';
import {
  fetchGetPopularCitiesForGeopopup,
  TGetPopularCitiesForGeopopupResponse,
} from '../../../../shared/repositories/geo-suggest/v1/get-popular-cities-for-geopopup';

export const getPopularCitiesForGeopopup = async () => {
  const response: TGetPopularCitiesForGeopopupResponse = await fetchGetPopularCitiesForGeopopup({
    httpApi: getHttpApi(),
    parameters: {},
  });

  if (response.statusCode !== 200) {
    throw new Error(response.response.message);
  }

  return response.response.cities;
};
